import PublicTeacherEducationTable from "./PublicTeacherEducationTable";

export default PublicTeacherEducationTable;